<template>
  <div class="cv" :id="id">
  </div>
</template>

<script>
import { Chart } from '@antv/g2'
export default {
  name: 'Abb',
  props: {
    id: {
      type: [Number, String],
      default: new Date().getTime()
    },
    config: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      graph: null,
      view1: null,
      view2: null,
      AllTotal: {
        '微博1': [
          { type: '论坛', value: 1.77 },
          { type: '网站', value: 1.44 },
          { type: '微信', value: 1.12 }
        ],
        '微博2': [
          { type: '论坛', value: 1.77 },
          { type: '网站', value: 1.44 },
          { type: '微信', value: 1.12 },
          { type: '客户端', value: 1.05 },
          { type: '新闻', value: 0.81 },
          { type: '视频', value: 0.39 }
        ],
        '其它': [
          { type: '论坛', value: 1 },
          { type: '网站', value: 1 },
          { type: '微信', value: 1 },
          { type: '客户端', value: 1 },
          { type: '新闻', value: 1 },
          { type: '视频', value: 1 },
          { type: '博客', value: 1 },
          { type: '报刊', value: 1 }
        ]
      },
      chooseAcItem: 99,
      chooseCriclePath: [],
      view1Geometries: null,
      view1Coorditate: null,
      barName: '',
      barStackData: []
    }
  },
  computed: {
    otherRatio () {
      return this.chooseAcItem / 100
    },
    otherOffsetAngle () {
      return this.otherRatio * Math.PI
    },
    getItemPath () {
      return this.chooseCriclePath
    }
  },
  created () {
    this.$bus.$on('abbreviation', this.checkTypeHandler)
    this.$once('hook:beforeDestory', () => {
      this.$bus.$off('chinaMap')
    })
  },
  mounted () {
    this.graph = new Chart({
      container: this.id,
      autoFit: true
    })
    this.graph.legend(false)
    this.graph.tooltip({
      showMarkers: false
    })
    this.initChartConfig()

    this.graph.render()
    let Vthat = this
    this.graph.on('afterpaint', function () {
      Vthat.drawLinkArea()
    })
    this.graph.on('interval:click', (ev) => {
      const intervalElement = ev.target.get('element')
      console.log(intervalElement)
      const data = intervalElement.getModel().data // 单条数据
      console.log(data)
      this.chooseAcItem = data.value
      this.chooseCriclePath = intervalElement?.shape?.attrs?.path
      console.log(this.view1Geometries[0]?.elementsMap['1-其它1'])
      this.drawLinkArea()
    })
    this.changeConfig(this.config)
  },
  watch: {
    'config': {
      deep: true,
      immediate: true,
      handler: function (newV, oldV) {
        this.changeConfig(newV)
      }
    },
    'chartData': {
      deep: true,
      immediate: true,
      handler: function (newV, oldV) {
        let ListsMapLists = Object.entries(newV?.mapLists ?? {})
        if (ListsMapLists.length > 0) {
          this.barName = ListsMapLists[0][0]
        }
      }
    }
  },
  methods: {
    checkTypeHandler (key) {
      console.log(key)
      this.graph.forceFit()
    },
    initChartConfig () {
      const name = `1-${this.barName}`
      let Vthat = this
      this.view1 = this.graph.createView({
        region: {
          start: {
            x: 0,
            y: 0
          },
          end: {
            x: 0.5,
            y: 1
          }
        }
      })
      this.view1Coorditate = this.view1.coordinate('theta', {
        radius: this.config.radius ?? 0.7,
        startAngle: 0,
        endAngle: Math.PI * 2
      })
      this.view1.data(this.chartData.data ?? [])
      this.view1.interaction('element-highlight')

      this.view1
        .interval()
        .adjust('stack')
        .position(`${this.config.valueField}`)
        .color(`${this.config.typeField}`, this.config.color ?? [])
        .label(`${this.config.valueField}`, {
          offset: -10,
          content: Vthat.abbConversionTagHandler(this.config?.view1?.label?.contentReg, this.config?.view1?.label?.dw),
          // content: (obj) => {
          //   return obj.type + '\n' + obj.value + '%'
          // }
          style: {
            fontSize: this.config?.view1?.label?.style?.size ?? 12,
            fill: this.config?.view1?.label?.style?.color ?? 'white'
          }
        })
      console.log(this.view1)
      this.view1Geometries = this.view1.geometries ?? []
      setTimeout(() => {
        this.chooseCriclePath = this.view1Geometries[0]?.elementsMap[name]?.shape?.attrs?.path
        console.log(this.view1.geometries[0].elementsMap[name])
        console.log(this.view1)
        console.log(Object.keys(this.view1.geometries[0].elementsMap))
        this.drawLinkArea()
      }, 100)
      this.view2 = this.graph.createView({
        region: {
          start: {
            x: 0.5,
            y: 0
          },
          end: {
            x: this.config.view2.endX ?? 1,
            y: 0.9
          }
        }
      })
      // position
      // inside---40
      // right---15
      this.view2.axis(false)
      // this.view2.data(this?.chartData?.mapLists[this.barName] ?? [])
      this.view2.data(this.changeView2DataConfig())
      this.view2.interaction('element-highlight')
      this.view2
        .interval()
        .adjust('stack')
        .position(this.config.view2.isV ? 'isV' : `${this.config.valueField}`)
        .color(`${this.config.typeField}`, ['#063d8a', '#0b53b0', '#1770d6', '#2593fc', '#47abfc', '#6dc1fc', '#94d6fd', '#bbe7fe'])
        .label(`${this.config.valueField}`, this.getView2LabelConfig())
      this.graph.render()
      this.drawLinkArea()
      let vThat = this
      this.graph.on('afterpaint', function () {
        vThat.drawLinkArea()
      })
    },
    drawLinkArea () {
      let name = `1-${this.barName}`
      this.chooseCriclePath = this.view1Geometries[0]?.elementsMap[name]?.shape?.attrs?.path
      const canvas = this.graph.getCanvas()
      const container = this.graph.backgroundGroup
      container.clear()
      const view1Coord = this.view1.getCoordinate()
      console.log(view1Coord)
      console.log(this.view1)
      const center = view1Coord.getCenter()
      const radius = view1Coord.getRadius()
      const intervalGeom = this.view2.geometries[0]
      const intervalContainer = intervalGeom.container
      const intervalBbox = intervalContainer.getBBox()
      const view2Coord = this.view2.getCoordinate()

      // this.view1Coorditate.rotate(Math.PI * Math.random())
      // this.graph.render()
      // area points
      const pieStart1 = {
        x: center.x + Math.cos(Math.PI * 2 - this.otherOffsetAngle) * radius,
        y: center.y + Math.sin(Math.PI * 2 - this.otherOffsetAngle) * radius
      }
      const pieStart2 = {
        x: center.x + Math.cos(this.otherOffsetAngle) * radius,
        y: center.y + Math.sin(this.otherOffsetAngle) * radius
      }
      const intervalEnd1 = {
        x: intervalBbox.minX,
        y: view2Coord.end.y
      }
      const intervalEnd2 = {
        x: intervalBbox.minX,
        y: view2Coord.start.y
      }
      let choosePath = this.chooseCriclePath ?? []
      console.log(choosePath)
      const path = [
        [
          'M',
          center.x,
          center.y
        ],
        [
          'L',
          choosePath?.[1]?.[1],
          choosePath?.[1]?.[2]
        ],
        [
          'L',
          intervalEnd2.x,
          intervalEnd2.y
        ],
        [
          'L',
          intervalEnd1.x,
          intervalEnd1.y
        ],
        [
          'L',
          choosePath?.[2]?.[6],
          choosePath?.[2]?.[7]
        ],
        [
          'L',
          center.x,
          center.y
        ],
        [
          'Z'
        ]
      ]

      container.addShape('path', {
        attrs: {
          path,
          fill: 'rgba(233,244,254,.1)'
        }
      })
      // canvas.draw()
    },
    changeConfig (newV) {
      if (this.graph) {
        if (newV.legendShow) {
          console.log(2222)
          this.graph.legend({
            position: newV.legend.position,
            offsetY: newV.legend.offsetY,
            offsetX: newV.legend.offsetX,
            itemSpacing: newV.legend.itemSpacing,
            marker: {
              symbol: newV.legend.marker.symbol
            },
            itemName: {
              style: {
                fill: 'white'
              }
            }
          })
        } else {
          this.graph.legend(false)
        }
        this.graph.clear()
        this.initChartConfig()
        this.graph.render()
      }
    },
    abbConversionTagHandler (str, dw) {
      return function (val) {
        return str.replace(/{([a-zA-Z$]+)}|(\\n|\n)/g, ($1, $2, $3) => {
          if ($2) { return val[$2] }
          if ($3) { return '\r\n' }
        }) + dw
      }
    },
    getView2LabelConfig () {
      let position = this.config?.view2?.label?.position ?? 'right'
      let offsetY = position === 'right' ? 15 : 40
      return {
        position: position,
        offsetX: 5,
        offsetY: offsetY,
        // content: (obj) => {
        //   return obj.type + '\n' + obj.value + '%'
        // },
        content: this.abbConversionTagHandler(this.config?.view2?.label?.contentReg, this.config?.view2?.label?.dw),
        style: {
          fontSize: this.config?.view2?.label?.style?.size ?? 12,
          fill: this.config?.view2?.label?.style?.color ?? 'white'
        }
      }
    },
    changeView2DataConfig () {
      let data = []
      if (this.config?.view2?.isV) {
        data = (this?.chartData?.mapLists[this.barName] ?? []).map(item => {
          item.isV = 1
          return item
        })
      } else {
        data = (this?.chartData?.mapLists[this.barName] ?? [])
      }
      return data
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.cv
  width 100%
  height 100%
</style>
